import { CheckCircle2, XCircle, SkipForward } from "lucide-react";

const LETTERS = "ABCDEF";

// End-of-video recap of every question; wrong answers highlighted with a jump-back link.
export const VideoQuizRecap = ({ cps, answers, onJump }) => (
  <ol className="w-full space-y-2 text-left" data-testid="video-quiz-recap">
    {cps.map((c, i) => {
      const a = answers[c.id];
      if (!a) return null;
      return (
        <li key={c.id} className={`rounded-xl border p-3 text-xs sm:text-sm ${a.correct ? "border-green-400/40 bg-green-500/10" : "border-rose-400/50 bg-rose-500/15"}`} data-testid={`recap-item-${i}`}>
          <div className="flex items-start gap-2">
            {a.correct ? <CheckCircle2 size={16} className="mt-0.5 shrink-0 text-green-300" /> : <XCircle size={16} className="mt-0.5 shrink-0 text-rose-300" />}
            <p className="flex-1 font-semibold">Q{i + 1}. {c.question}</p>
          </div>
          <div className="mt-1.5 space-y-1 pl-6">
            {!a.correct && <p className="text-rose-200" data-testid={`recap-your-answer-${i}`}>Your answer: {LETTERS[a.selected]}. {c.options[a.selected]}</p>}
            <p className="text-green-200" data-testid={`recap-correct-answer-${i}`}>{a.correct ? "You answered" : "Correct answer"}: {LETTERS[a.correct_index]}. {c.options[a.correct_index]}</p>
            {a.explanation && <p className="text-white/70" data-testid={`recap-explanation-${i}`}>{a.explanation}</p>}
            {!a.correct && (
              <button onClick={() => onJump(i)} className="inline-flex items-center gap-1 pt-0.5 text-xs font-semibold text-sky-300 hover:underline" data-testid={`recap-jump-${i}`}>
                <SkipForward size={12} /> Jump to this question
              </button>
            )}
          </div>
        </li>
      );
    })}
  </ol>
);
